const arrayInject = (originalArray: Array<any>, insertArray: Array<any>, index: number) => {
  const array = originalArray || [];
  const subArray = insertArray || [];

  const firstChunk = [...array].slice(0, index);

  const lastChunk = [...array].splice(index + subArray.length, array.length);

  return [...firstChunk, ...subArray, ...lastChunk];
};

export default arrayInject;
